import { DataLoginDto } from "@dtos/data-login.dto";
import { BaseConverter } from "@converters/base.converter";
import { DataLogin } from "@models/data-login.model";

export class DataloginConverter extends BaseConverter <DataLogin,DataLoginDto>{

    modelToDto(model: DataLogin): DataLoginDto {
        return new DataLoginDto(
            model.username,
            model.password
        )
    }
    dtoToModel(dto: DataLoginDto): DataLogin {
        return new DataLogin(
            dto.username,
            dto.password
        )
    }

}